import { EDUCATION_ROUTE_NAME, TRAINING_ROUTE_NAME } from '~/features/routeNames';
import { getData } from '~/utils/service';
import { DashAcademicResponse, DashboardAcademics, Scope } from './types';
import { eduApiToDashAcademics, trainingApiToDashboardAcademics } from './utils';

export const ACADEMICS_API_CALLS = {
  get: async ({ input }: { input: Scope }): Promise<DashAcademicResponse> => {
    const academics: DashboardAcademics[] = [];

    const educationGet: Promise<DashAcademicResponse> = getData(EDUCATION_ROUTE_NAME, {
      transformResponse: eduApiToDashAcademics,
      params: { providerId: input.context.providerId },
    });

    const trainingGet: Promise<DashAcademicResponse> = getData(TRAINING_ROUTE_NAME, {
      transformResponse: trainingApiToDashboardAcademics,
      // params: { providerId: input.context.providerId, user_added_flag: false },
    });

    await Promise.all([educationGet, trainingGet]).then((responses) => {
      responses.forEach((objs) => {
        objs.data.forEach((academic) => {
          academics.push(academic);
        });
      });
    });

    return {
      data: academics,
    };
  },
};
